import * as React from 'react';
import { ToWaveformNumeric, WaveformType } from '../interfaces/state';

interface DownloadButtonProps {
    sessionId: string;
    waveformType: string;
}

declare const coughMarshalRootUrl: string;
const coughMarshalPlaybackRoot = `${coughMarshalRootUrl}/api/v1/playback`;

export const DownloadButton = (props: DownloadButtonProps) => {
    const waveform = ToWaveformNumeric(props.waveformType as WaveformType);
    const filePath = `${coughMarshalPlaybackRoot}/download/${props.sessionId}/${waveform}`;

    return (
        <a href={filePath} className="btn btn-primary">
            Download
        </a>
    );
}
